<template>
    <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition" :overlay="false">
        <v-card>
            <v-toolbar fixed dark class="primary">
                <v-btn icon @click.native="close" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-container v-if="type != null" fluid fill-height>
                <div ref="tagFilterEl" v-if="type != 'prodGroup'">
                    <TagFilter ref="sd" @resize="fixHeight" @text="newV => (filterText = newV)" target="prodSelector" />
                </div>
                <v-list class="vlist" :style="{height: listHeight}" two-line>
                    <virtual-scroller class="scroller" :items="items" item-height="75">
                        <template slot-scope="props">
                            <v-list-tile
                                tag="div"
                                :ripple="false"
                                avatar
                                :class="[isSelected(props.item), 'selectableRow']"
                                @click.native.stop="add(props.item)"
                                :item="props.item"
                                :key="props.item._id"
                            >
                                <v-list-tile-avatar>
                                    <img :src="imgUrl(props.item.img)" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ getDescr(props.item) }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ getFather(props.item) }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="props.item.tipo !== 'tag'">
                                    <p>{{ $n(getPrice(props.item), 'currency', 'it') }}</p>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </virtual-scroller>
                </v-list>
                <v-btn fixed dark fab bottom right @click.native="procede" class="orange floatingBtn">
                    <v-icon>save</v-icon>
                </v-btn>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Dialog per la selezione di prodotti da aggiungere al menu
 * @module components/common/ProdSelector
 */
import TagFilter from '@/components/common/TagFilter.vue';
export default {
    name: 'prodSelector',
    data() {
        return {
            filterText: '',
            filterLvl: 1,
            specific: null,
            selected: null,
            selectedRows: [],
            listHeight: '100%',
        };
    },
    beforeMount() {
        this.filterText = '';
    },
    components: {
        TagFilter,
    },
    methods: {
        fixHeight() {
            let that = this;
            setTimeout(() => {
                that.listHeight = `calc(100% - ${that.$refs.tagFilterEl.clientHeight}px)`;
            });
        },
        isSelected(item) {
            return this.selectedRows.findIndex(row => row == item._id) != -1 ? 'item-to-insert' : '';
        },
        add(item) {
            if (this.type == 'prodGroup') {
                this.filterText = '';
                this.$emit('close', item._id);
                this.$store.dispatch('RESETLIBFILTER', {target: 'prodSelector'});
            } else {
                let index = this.selectedRows.findIndex(row => row == item._id);
                if (index != -1) this.selectedRows.splice(index, 1);
                else this.selectedRows.push(item._id);
            }

            this.$forceUpdate();
        },
        procede() {
            this.filterText = '';
            this.$emit('close', this.selectedRows);
            this.selectedRows = [];
            this.$store.dispatch('RESETLIBFILTER', {target: 'prodSelector'});
        },
        getDescr(item) {
            return utils.getMainDesc(item);
        },
        imgUrl(item) {
            return utils.getImgUrl(item);
        },
        close() {
            this.filterText = '';
            this.selectedRows = [];
            this.$emit('close', null);
            this.$store.dispatch('RESETLIBFILTER', {target: 'prodSelector'});
        },
        getFather(item) {
            if (item.tipo === 'prod') {
                return item.levelDescription;
            } else {
                if (item.padre) {
                    const tags = this.$store.getters.Tag;
                    const productTag = tags.find(element => element._id === item.padre);
                    const tagName = this.getDescr(productTag);
                    return `BASE - ${tagName}`;
                } else {
                    return 'BASE';
                }
            }
        },
        getPrice(item) {
            const currentListing = this.$store.getters.currentListino;
            const price = item.prezzo.find(element => element.listino === currentListing && element.when === 'prod');
            return price.prezzop;
        },
        compare(a, b) {
            if (a.descrizione[0].contenuto < b.descrizione[0].contenuto) {
                return -1;
            }
            if (a.descrizione[0].contenuto > b.descrizione[0].contenuto) {
                return 1;
            }
            return 0;
        },
    },
    computed: {
        dialog() {
            return this.type != null;
        },
        title() {
            if (this.type == 'group' || this.type == 'prodGroup') return 'Seleziona un gruppo';
            if (this.type == 'prod') return 'Seleziona i prodotti';
        },
        items() {
            let sortedResponse;

            if (this.type == 'prod') {
                this.$store.dispatch('LIBSELECTEDTAB', 'prod');
                const filteredResponse = this.$store.getters.filteredPvi(this.filterText, 'prodSelector');
                sortedResponse = filteredResponse.sort((a, b) => this.compare(a, b));
            } else {
                const response = this.$store.getters.Tag;
                sortedResponse = response.sort((a, b) => this.compare(a, b));
                /*
            var treeList = [];
            response.forEach(tag => {
                let padre = response.find(cTag => cTag._id == tag.padre);
                if (!padre) {
                    treeList.push(tag);
                } else {
                    let friends = treeList.filter(cTag => cTag.padre === tag.padre);
                    let friendsIndex = friends.map(friend => treeList.findIndex(cTag => friend._id === cTag._id));
                    let insertIndex = treeList.findIndex(cTag => cTag._id === tag.padre) + 1;
                    if (friendsIndex.length != 0) {
                        friendsIndex.forEach(index => {
                            if (utils.getMainDesc(treeList[index]) < utils.getMainDesc(tag))
                                insertIndex++;
                        })
                        treeList.splice(insertIndex, 0, tag);
                    } else {
                        treeList.splice(treeList.findIndex(cTag => cTag._id === tag.padre) + 1, 0, tag);
                    }
                }
            })
            return treeList;
            */
            }
            return sortedResponse;
        },
        tags() {
            return this.$store.getters.Tag;
        },
    },
    /**
     * @prop type {string} - Tipo di oggetto da aggiungere ( group / comb / prodGroup / prod )
     */
    props: ['type'],
};
</script>

<style lang="stylus" scoped>
.container
  padding-top: 64px
  height: 100vh
  overflow hidden
.vlist
.vlist-container-lib
  height: 100%
.selectableRow
  cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/common/ProdSelector.vue